import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import Card1 from "../Images/Profiles/Isaac Ahimbisiibwe_Profile Pic.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function IsaacAhimbisiibwe() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Isaac Ahimbisiibwe - Research Associate"
        description="Mr. Isaac Ahimbisiibwe is a Research Associate at CIRCODU with a Master's Degree in Gender Studies and a Bachelor's Degree in Social Sciences."
        keywords="Isaac Ahimbisiibwe, Research Associate, CIRCODU, Master's Degree, Bachelor's Degree, Gender Studies, Social Sciences"
        url="/isaac-ahimbisiibwe"
        image={Card1}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Isaac Ahimbisiibwe</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Isaac Ahimbisiibwe
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card1} alt="Mr. Isaac Ahimbisiibwe" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Isaac Ahimbisiibwe</h1>
                <p className="profile-card__role">Research Associate</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Isaac Ahimbisiibwe's academic achievements and professional
                  journey are worthy noting. He earned a Master's Degree in
                  Gender Studies from Makerere University in Uganda. He further
                  expanded his knowledge by completing a Post Graduate Course on
                  "Beyond Income: Social Dimensions of Poverty and Participatory
                  Methodologies of Investigation" at Oslo and Akershus
                  University College of Applied Sciences (HiOA) in Norway.
                </p>
                <p>
                  Isaac's foundational education includes a Bachelor of Arts in
                  Social Sciences from Makerere University, with a focus on
                  Gender Studies as his major and Sociology as his minor.
                </p>
                <p>
                  With a career spanning over ten years, Isaac has amassed
                  extensive expertise in the realms of Social Work and
                  Institutional Development. His proficiencies encompass various
                  domains such as Research, Report Writing, Strategic Planning,
                  and Community Mobilization.
                </p>
                <p>
                  Isaac's skill set extends to the digital sphere as well. He
                  possesses adept Computer Skills, displaying proficiency in
                  applications including Ms Excel, Ms Word, Ms PowerPoint, Ms
                  Access, and Web Surfing.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/isaac-ahimbisiibwe-883919162/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/IsaacAhimbisii1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://m.facebook.com/people/Isaac-Ahimbisiibwe/100010181948317/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256752814376"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:isaac.ahimbisiibwe@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default IsaacAhimbisiibwe;
